import classNames from 'classnames';
import { forwardRef } from 'react';
import { useIsWideMainLayout, useIsZeroPaddingMainLayout } from './hooks';
const containerOuterCss = "ckp8fa6";
const containerInnerCss = "citxq8s";
const containerInnerWideCss = "c3s70al";
const Container = forwardRef((props, ref) => {
  const {
    isWide,
    zeroPadding,
    as: AsComponent,
    children,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerOuterCss, {
    zeroPadding
  }, props.className)}>
      <div className={classNames(containerInnerCss, {
      [containerInnerWideCss]: isWide
    })}>
        {children}
      </div>
    </Component>;
});
export const MainRegion = ({
  children
}) => {
  const [isWide] = useIsWideMainLayout();
  const [zeroPadding] = useIsZeroPaddingMainLayout();
  return <Container isWide={isWide} zeroPadding={zeroPadding}>
      {children}
    </Container>;
};

require("./region.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./region.js");